var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8649 4.19364L10.0724 8.44364C1.47326 11.3195 1.47326 16.0086 10.0724 18.8703L13.8691 20.1311L15.1299 23.9278C17.9916 32.527 22.6949 32.527 25.5566 23.9278L29.8208 11.1495C31.7191 5.41197 28.6024 2.28114 22.8649 4.19364ZM23.3183 11.8153L17.9349 17.227C17.7224 17.4395 17.4533 17.5386 17.1841 17.5386C16.9149 17.5386 16.6458 17.4395 16.4333 17.227C16.2357 17.027 16.1248 16.7572 16.1248 16.4761C16.1248 16.195 16.2357 15.9253 16.4333 15.7253L21.8166 10.3136C22.2274 9.9028 22.9074 9.9028 23.3183 10.3136C23.7291 10.7245 23.7291 11.4045 23.3183 11.8153Z",
    fill: "#283593"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplan);
export default __webpack_public_path__ + "static/media/paperplan.8bf6d6801fd3594f97bc1a3c125cae60.svg";
export { ForwardRef as ReactComponent };